export default {
  //-----------------------------native----------------------------------------
  updateImageSrc(state, payload) {
    state.urlData.image_src = payload;
  },
  updateScheme(state, payload) {
    state.urlData.source_scheme = payload;
  },
  updatePlatform(state, payload) {
    state.urlData.platform = payload;
  },
  updateUsername(state, payload) {
    state.urlData.username = payload;
  },
  updateFullname(state, payload) {
    state.urlData.full_name = payload;
  },
  updateUserCoin(state, payload) {
    state.urlData.user_coin = payload;
  },
  updateMver(state, payload) {
    state.urlData.mver = payload;
  },
  updateFollowCount(state, payload) {
    state.urlData.follow_count = payload;
  },
  updateLikeCount(state, payload) {
    //like
    state.urlData.like_count = payload;
  },
  updateViewCount(state, payload) {
    //view
    state.urlData.view_count = payload;
  },
  updateCommentCount(state, payload) {
    //comment
    state.urlData.comment_count = payload;
  },
  updateLikeTabData(state, payload) {
    //likeTabData
    state.likeTabData = payload;
  },
  updateMediaListTag(state, payload) {
    //mediaListTag
    state.mediaListTag = payload.mediaListTag;
  },
  updateUserMediaList(state, payload) {
    //来用户media
    for (var i in payload.userMediaList) {
      state.userMediaList.push(payload.userMediaList[i]);
    }
  },
  updateProductKind(state, payload) {
    state.urlData.product_kind = payload;
  },
  updateUserJson(state, payload) {
    state.urlData.userJson = payload;
  },
  updateTaskJson(state, payload) {
    state.urlData.taskJson = payload;
  },
  updateOfferId(state, payload) {
    state.urlData.offer_id = payload;
  },
  updateAppKind(state, payload) {
    state.urlData.app_kind = payload;
  },
  updateConfirmShow(state, payload) {
    state.confirmShow = payload;
  },
  updateSettingData(state, payload) {
    state.settingData = payload.settingData;
  },
  updateGetType(state, payload) {
    state.getType = payload;
  },
  updateHistoryBackShow(state, payload) {
    state.historyBackShow = payload;
  },
  updateCoinShow(state, payload) {
    state.coinShow = payload;
  },
  updateCollectShow(state, payload) {
    //收藏按钮
    state.collectShow = payload;
  },
  updateSchemeUrl(state, payload) {
    state.schemeUrl = payload;
  },
  updateTaskJsonSign(state, payload) {
    state.taskJsonSign = payload;
  },
  updateDataUrl(state, payload) {
    state.dataUrl = payload;
  },
  updateTabSeleced(state, payload) {
    state.tabSeleced = payload;
  },
  updateLoadingShow(state, payload) {
    //loading
    state.loadingShow = payload;
  },
  updateGuideShow(state, payload) {
    //首次进来的引导页
    state.web_guide_show = payload.web_guide_show;
  },
  updateMidLoadingShow(state, payload) {
    //过度loading
    state.midLoadingShow = payload.midLoadingShow;
    state.midLoadingText = payload.midLoadingText;
  },
  updatePostData(state, payload) {
    state.postData = payload;
  },
  updateNavTitleName(state, payload) {
    state.navTitleName = payload;
  },
  updateUserInfo(state, payload) {
    state.userInfo = payload.userInfo;
  },
  updateTabbarShow(state, payload) {
    state.tabbarShow = payload;
  },
  updateAllUrlData(state, payload) {
    state.urlData = payload.urlData;
  },
  updateMtStatus(state, payload) {
    //url开关，开启和关闭tabbar
    state.mtStatus = payload;
  },
  updateSubsFollowMonth(state, payload) {
    state.subs_follow_month = payload;
  },
  updateSubsLikeMonth(state, payload) {
    state.subs_like_month = payload;
  },
  updateSubsFollowWeek(state, payload) {
    state.subs_follow_week = payload;
  },
  updateSubsLikeWeek(state, payload) {
    state.subs_like_week = payload;
  },
  updateVipStatus(state, payload) {
    state.vipStatus = payload;
  },
  updateVipList(state, payload) {
    state.vip_list = payload;
  },
  updateToastShow(state, payload) {
    state.toastShow = payload.toastShow;
    if (payload.hasOwnProperty("toastText")) {
      state.toastText = payload.toastText;
    }
    if (payload.hasOwnProperty("position")) {
      state.toastPosition = payload.position;
    }
  },
  updateNavbarShow(state, payload) {
    //nav
    state.navbarShow = payload.navbarShow;
  },
  updateSubsTabShow(state, payload) {
    //记住用户所点击的tab
    state.subs_tab_show = payload.subs_tab_show;
  },
  //----------------------------web---------------------------------------
  updateWebTabbarShow(state, payload) {
    // tab
    state.web_tabbar_show = payload.web_tabbar_show;
  },
  updateWebNavbarShow(state, payload) {
    //navbarShow
    state.web_navbar_show = payload.web_navbar_show;
  },
  updateWebNavImgShow(state, payload) {
    // img
    state.web_navimg_show = payload.web_navimg_show;
  },
  updateCurrentUserData(state, payload) {
    state.currentUserData = payload.currentUserData;
  },
  upadteServiceList(state, payload) {
    state.service_list = payload;
  },
  // updateMediaListTags(state,payload){
  //   state.mediaListTags=payload.mediaListTags
  // },
  updateAllPostCate(state, payload) {
    //用户所需显示的类型
    state.allPostCate = payload.allPostCate;
  },
  updateAllPostData(state, payload) {
    state.allPostData = payload.allPostData;
  },
  updateAllPostSelectedId(state, payload) {
    state.allPostSelectedId = payload.allPostSelectedId;
  },
  updateAccountShow(state, payload) {
    state.web_account_show = payload.web_account_show;
  },
  updateAccountHistoryShow(state, payload) {
    state.web_account_history_show = payload.web_account_history_show;
  },
  updateLoginShow(state, payload) {
    state.web_login_show = payload.web_login_show;
  },
  updateAnonterCountShow(state, payload) {
    state.web_another_account_show = payload.web_another_account_show;
  },
  updateHistoryData(state, payload) {
    state.web_history_data = payload.web_history_data;
    if (payload.id) {
      let usersData = localStorage.getItem("usersData");
      if (usersData) {
        let newArr = JSON.parse(usersData);

        for (let i in newArr) {
          if (newArr[i].userId == payload.id) {
            let dataJson = newArr[i];
            newArr.splice(i, 1);
            newArr.unshift(dataJson);
            break;
          }
        }
        localStorage.setItem("usersData", JSON.stringify(newArr));
        state.web_history_data = newArr;
      } else if (usersData == null || userData.lenght == 0) {
        state.web_history_data = [];
      }
    }
  },
  updateEditButtonShow(state, payload) {
    state.web_edit_button_show = payload.web_edit_button_show;
  },
  updateAccountData(state, payload) {
    let usersData = localStorage.getItem("usersData");
    if (usersData) {
      let newArr = JSON.parse(usersData);
      for (let i in newArr) {
        if (newArr[i].userId == payload.id) {
          let dataJson = newArr[i];
          newArr.splice(i, 1);
          newArr.unshift(dataJson);
          break;
        }
      }
      state.web_account_data = newArr;
    } else if (usersData == null || userData.lenght == 0) {
      state.web_account_data = [];
    }
  },
  updateAddHomeShow(state, payload) {
    if (payload.addHome == true) {
      let isSafari =
        navigator.vendor &&
        navigator.vendor.indexOf("Apple") > -1 &&
        navigator.userAgent.indexOf("Safari") > -1 &&
        !navigator.userAgent.match("CriOS");
      // let isSafari = true;
      if (navigator.userAgent.match(/(iPhone|iPod|iPad|iOS);?/i) && isSafari) {
        state.web_ios_addHome_show = true;
      } else if (navigator.userAgent.match(/Android/i)) {
        state.web_android_addHome_show = true;
      }
    } else {
      state.web_ios_addHome_show = false;
      state.web_android_addHome_show = false;
    }
  },
  updateAdsShow(state, payload) {
    //payload:{
    //      adsShow:true,
    //       android:false  //用来判定某个路由下才显示的mark
    //      }
    if (payload.adsShow) {
      // if(navigator.userAgent.indexOf("Safari")==-1&&navigator.userAgent.match(/(iPhone|iPod|iPad|iOS);?/i)){//不为safari浏览器 并且为ios系统
      //   state.web_safari_ads_show=true;
      //   console.info("不为safari浏览器 并且为ios系统")
      // }else if (navigator.userAgent.match(/Android/i)) { //安卓手机显示底部的ads
      //   if(payload.android){
      //     state.web_android_ads_show=true;
      //   }else{
      //     state.web_android_ads_show=false;
      //   }
      // }

      if (sessionStorage.getItem("adsShow")) {
        //如果存在session
        if (sessionStorage.getItem("adsShow") == "on") {
          state.web_android_ads_show = true;
        } else {
          state.web_android_ads_show = false;
        }
      } else {
        state.web_android_ads_show = true;
      }
    } else {
      state.web_safari_ads_show = false;
      state.web_android_ads_show = false;
    }
  },
  updateLoginDetailShow(state, payload) {
    state.web_login_detail_show = payload.web_login_detail_show;
  },
  updateWebPaymentShow(state, payload) {
    state.web_payment_show = payload.web_payment_show;
  },
  updatePaymentResult(state, payload) {
    state.pay_result = payload.pay_result;
  },
  updatePaymentResultShowed(state, payload) {
    state.payment_had_show = payload.payment_had_show;
  },
  updateFreePaymentShow(state, payload) {
    state.web_free_payment_show = payload.web_free_payment_show;
  },
  updateFreeListShow(state, payload) {
    state.freeListShow = payload.freeListShow;
  },
  updateMasterId(state, payload) {
    state.masterId = payload;
  }
};



// WEBPACK FOOTER //
// ./src/vuex/mutation.js